import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static values = {
    hideAt: String
  }

  connect() {
    const hideAt = new Date(this.hideAtValue);
    const now = new Date();
    const timeUntilHide = hideAt - now;

    if (timeUntilHide > 0) {
      setTimeout(() => {
        this.element.style.display = "none";
      }, timeUntilHide);
    } else {
      this.element.style.display = "none";
    }
  }
}
